// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kwM_","col":"styles_col__kmEuE"};